import { EventEmitter, Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class SideNavService {
  public appDrawer: MatSidenav;
  public sidenavChange = false;
  public currentUrl = new BehaviorSubject<string>(undefined);
  public sidenavChangeObs = new BehaviorSubject<boolean>(false);
  private parentDisplayName: string = "";

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  public toggle(): void {
    this.sidenavChange = !this.sidenavChange;
    this.sidenavChangeObs.next(this.sidenavChange);
    this.appDrawer.toggle();
  }

  public setParentDisplayName(displayName: string): void {
    this.parentDisplayName = displayName;
  }

  public getParentDisplayName(): string {
    return this.parentDisplayName;
  }
}